import styles from './style.module.css';
export const Banner = () => {
  return (
    <div className={styles.container}>
      <div className={styles.bannerWrapper}>
        <div className={styles.bannerText}>Get the best deal while experiencing the best of online shopping experience </div>
        <div className={styles.mann}>
          <div className={styles.ellipseL}></div>
          <div className={styles.ellipseR}></div>
        </div>
        <img src={require('../../../assets/images/mannequinImage.png')} height={239} className={styles.img} alt="Mannequin Image" />
      </div>
    </div>
  );
};
